import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import { FreeMode, Autoplay } from 'swiper/modules';

import threeemlogo from '../images/3m-logo.png';
import nexperialogo from '../images/nexperia-icon.png';
import safranlogo from '../images/safran-landing-system.png';
import presslogo from '../images/press-metal-aluminium-logo.png';
import lyondellBaselllogo from '../images/lyondellBasell-polymers-logo.png';
import cpaklogo from '../images/c-pak-logo.png';

const baseLogos = [threeemlogo, nexperialogo, safranlogo, presslogo ,lyondellBaselllogo ,cpaklogo ];

const logos = [...baseLogos, ...baseLogos];

export default function LogoSlider() {
    return (
        <>
            <section className='lg:max-w-[80%] pb-20 space-y-4 mt-4'>
                <div className="flex items-center gap-4 ">
                    <span className="text-sm text-gray-400 whitespace-nowrap">
                        Shaping developer experiences for the future
                    </span>
                    <div className="flex-1 border-t border-gray-700 "></div>
                </div>
                <Swiper
                    modules={[FreeMode, Autoplay]}
                    slidesPerView={'auto'}
                    spaceBetween={30}
                    loop={true}
                    speed={6000}
                    autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                    }}
                    freeMode={{
                        enabled: true,
                        sticky: false,
                        momentum: false,
                    }}
                    grabCursor
                    className="mt-4"
                >
                    {logos.map((src, idx) => (
                        <SwiperSlide key={idx} className="!w-auto">
                            <img
                                src={src}
                                alt={`logo-${idx}`}
                                className="h-10 opacity-70 hover:opacity-100 transition"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>

        </>


    );
}
